import connector from "./connector";
import Auth from "./Auth"
import Supervision from "./Supervision"
import Classifiers from "./Classifiers"
import Users from "./Users"
import Organizations from "./Organizations"
import Layouts from "./Layouts"

class Repository {
  connector = connector
  Auth = Auth
  Supervision = Supervision
  Classifiers = Classifiers
  Users = Users
  Organizations = Organizations
  Layouts = Layouts
}

export default new Repository();
